
import axios from 'axios';
import moment from 'moment/moment';

export default {
  name: 'DepartmentCostPane',

  props: {
    'detailsUrl': {type: String, required: true},
    'department': {type: Number, required: true},
    'year': {type: Number, required: true},
  },

  data() {
    return {
      busy: false,
      error: null,
      fields: [
        {
          key: 'invoiceDate', label: 'Rechnungsdatum', sortable: true,
          filter: {type: 'string-contains', value: ''},
          formatter: ({value}) => this.formatDate(value), filterByFormatted: true,
        },
        {
          key: 'articleName', label: 'Artikel', sortable: true,
          filter: {type: 'string-contains', value: ''},
        },
        {
          key: 'units', label: 'Menge', tdClass: 'text-end', sortable: true,
          filter: {type: 'string-contains', value: ''},
        },
        {
          key: 'cost', label: 'Gesamtpreis', tdClass: 'text-end', sortable: true,
          filter: {type: 'decimal-number-contains', value: ''},
          formatter: ({value}) => this.formatCurrency(value), filterByFormatted: true,
        },
      ],
      items: [],
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        // go through all filters
        return this.fields.filter((field) => field.filter).every((field) => {
          const filter = field.filter;
          // filter for string fields
          if (filter.type === 'string-contains') {
            if (filter.value === '') return true;
            if (field.filterByFormatted) {
              return String(field.formatter({value: item[field.key]})).includes(filter.value.toString());
            } else {
              return String(item[field.key]).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
                  .includes(filter.value.toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''));
            }
          }
          if (filter.type === 'string-equals') {
            if (filter.value === '') {
              return true;
            }
            if (field.filterByFormatted) {
              return String(field.formatter({value: item[field.key]})) === (filter.value.toString());
            } else {
              return String(item[field.key]).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '') ===
                  filter.value.toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
            }
          }
          if (filter.type === 'decimal-number-contains') {
            if (filter.value === '') {
              return true;
            }
            if (field.filterByFormatted) {
              if (filter.value.includes('.')) {
                return field.formatter({value: item[field.key]})
                    .includes(filter.value);
              } else {
                return field.formatter({value: item[field.key]}).replace(/\./g, '')
                    .includes(filter.value);
              }
            }
          }
          // filter for multiselects
          if (filter.type === 'multiselect') {
            if (!filter.value.length) {
              return true;
            }
            return filter.value.some((filter) => {
              return item[field.key] === filter.id;
            });
          }
        });
      });
    },
  },
  watch: {
    department() {
      this.fetchData();
    },
    year() {
      this.fetchData();
    },
  },
  mounted() {
    this.calculateContainerHeight();
    window.addEventListener('resize', this.calculateContainerHeight);
  },
  methods: {
    fetchData() {
      this.busy = true;
      return axios.get(this.detailsUrl, {
        params: {
          department: this.department,
          year: this.year,
        },
      }).then((response) => {
        this.items = response.data;
      }).catch((error) => {
        this.error = error;
        this.items = [];
      }).finally(() => {
        this.busy = false;
      });
    },
    resetFilters() {
      this.fields.filter((field) => field.filter).forEach((field) => field.filter.value = '');
    },
    formatCurrency(value) {
      const formatter = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
      return formatter.format(value);
    },
    formatDate(value) {
      return null !== value ? moment(value.date).format('DD.MM.YYYY') : '';
    },
    calculateContainerHeight() {
      const tableContainer = $('#table-container');
      const windowHeight = $(window).height();
      const offsetTop = tableContainer.offset().top;
      const footerHeight = $('footer').outerHeight();
      const correction = 16; // due to 1rem margin on footer
      const containerHeight = windowHeight - offsetTop - footerHeight - correction;
      tableContainer.height(containerHeight);
    },
  },
};
